import React, { Component } from "react";
import { connect } from "react-redux";
import { professionalAction } from "../../_actions";
import {
  Button,
  Checkbox,
  Col,
  Input,
  Modal,
  Row,
  Select,
  Space,
  Table,
  Tag,
  message,
} from "antd";
import { ClearOutlined, SearchOutlined } from "@ant-design/icons";
import { LanguageContext } from "../../context/LanguageContext";
import { adminService } from "../../_services/admin.service";
import moment from "moment";
import { ViewFormModel } from "../ProfessionalForm/ViewForm/ViewFormModel";
const { Option } = Select;

class GunhaHideRequest extends Component {
  static contextType = LanguageContext;
  state = {
    data: [],
    filteredData: [],
    loading: false,
    selectedCity: undefined,
    searchText: "",
    appliedCity: undefined,
    setCriminalViewModel: false,
    appliedSearchText: "",
    approveFilter: "pending",
    pagination: {
      current: 1,
      pageSize: 10,
      showSizeChanger: true,
      pageSizeOptions: ["10", "20", "50", "100"],
    },
    approveConfirmVisible: false,
    selectedRequests: [],
    selectedRowKeys: [],
    approveLoading: false,
    states: [],
    cities: [],
    selected_state: undefined,
  };

  isApproved = (record) =>
    record?.is_approve === true || record?.is_approve === 1;

  getPendingRecords = () =>
    (this.state.filteredData || []).filter((item) => !this.isApproved(item));

  getSelectedPendingRecords = () => {
    const { selectedRowKeys } = this.state;
    return this.getPendingRecords().filter((item) =>
      selectedRowKeys.includes(item.id),
    );
  };

  getCountry = () => {
    professionalAction.getCountry().then((res) => {
      this.setState({
        states: res.pc_countrystates,
      });
    });
  };

  GunahaHideRequestList = () => {
    this.setState({
      loading: true,
    });
    adminService.GunahaHideRequestList().then((res) => {
      const data = res.results || [];
      this.setState(
        {
          data,
          loading: false,
          selectedRowKeys: [],
        },
        () => this.applyFilters(),
      );
    });
  };

  onCityChange = (value) => {
    this.setState({ selectedCity: value });
  };

  onSearchTextChange = (e) => {
    this.setState({ searchText: e.target.value });
  };

  applyFilters = () => {
    const { data, appliedCity, appliedSearchText, approveFilter } = this.state;
    const search = String(appliedSearchText || "")
      .trim()
      .toLowerCase();

    let filteredData = data;

    if (approveFilter === "approved") {
      filteredData = filteredData.filter(
        (item) => item.is_approve === true || item.is_approve === 1,
      );
    } else if (approveFilter === "pending") {
      filteredData = filteredData.filter(
        (item) => !item.is_approve || item.is_approve === 0,
      );
    }

    if (
      appliedCity !== undefined &&
      appliedCity !== null &&
      appliedCity !== ""
    ) {
      filteredData = filteredData.filter(
        (item) =>
          Number(item.city) === Number(appliedCity) ||
          Number(item.cityId) === Number(appliedCity),
      );
    }

    if (search) {
      filteredData = filteredData.filter((item) => {
        const values = [
          item.userid,
          item.user_district_name,
          item.name,
          item.registernumber,
          item.lawSection,
          item.City,
          item.district_name,
          item.ip_address,
          item.reason,
          item.masterId,
        ];
        return values.some((val) =>
          String(val || "")
            .toLowerCase()
            .includes(search),
        );
      });
    }

    const selectedRowKeys = (this.state.selectedRowKeys || []).filter((key) =>
      filteredData.some((item) => item.id === key && !this.isApproved(item)),
    );

    this.setState({
      filteredData,
      selectedRowKeys,
      pagination: {
        ...this.state.pagination,
        current: 1,
      },
    });
  };

  onApproveFilterChange = (value) => {
    this.setState({ approveFilter: value }, () => this.applyFilters());
  };

  onSearch = () => {
    this.setState(
      {
        appliedCity: this.state.selectedCity,
        appliedSearchText: this.state.searchText,
      },
      () => this.applyFilters(),
    );
  };

  onClear = () => {
    this.setState(
      {
        selectedCity: undefined,
        searchText: "",
        appliedCity: undefined,
        appliedSearchText: "",
        selected_state: undefined,
        cities: [],
      },
      () => this.applyFilters(),
    );
  };

  handleTableChange = (pagination) => {
    this.setState({
      pagination: {
        ...this.state.pagination,
        ...pagination,
      },
    });
  };

  componentDidMount = () => {
    this.GunahaHideRequestList();
    this.props.dispatch(professionalAction.getCity());
    this.getCountry();
  };

  getStatesWiseCityData = (id) => {
    professionalAction.getStatesWiseCityData(id).then((res) => {
      this.setState({
        cities: res.pc_citiesData,
      });
    });
  };

  showCriminalViewModel = () => {
    this.setState({
      setCriminalViewModel: true,
    });
  };

  onViewAccusedForm = (data) => {
    if (data) {
      this.showCriminalViewModel();
      this.props.dispatch(professionalAction.getCriminalsViewsById(data));
    }
  };
  closeCriminalViewModel = () => {
    this.setState({
      setCriminalViewModel: false,
    });
  };

  onSelectChange = (selectedRowKeys) => {
    this.setState({ selectedRowKeys });
  };

  onSelectAllPending = (e) => {
    if (e.target.checked) {
      this.setState({
        selectedRowKeys: this.getPendingRecords().map((item) => item.id),
      });
    } else {
      this.setState({ selectedRowKeys: [] });
    }
  };

  openApproveConfirm = (record) => {
    this.setState({
      approveConfirmVisible: true,
      selectedRequests: [record],
    });
  };

  openBulkApproveConfirm = () => {
    const selectedRequests = this.getSelectedPendingRecords();
    if (!selectedRequests.length) {
      message.warning("Please select at least one pending request");
      return;
    }
    this.setState({
      approveConfirmVisible: true,
      selectedRequests,
    });
  };

  closeApproveConfirm = () => {
    this.setState({
      approveConfirmVisible: false,
      selectedRequests: [],
      approveLoading: false,
    });
  };

  onApproveConfirm = () => {
    const selectedRequests = this.state.selectedRequests || [];
    if (!selectedRequests.length) {
      message.error("No request selected");
      return;
    }

    const gunhaIds = [];
    const ids = [];
    for (const record of selectedRequests) {
      const gunhaId = record?.gunaId || record?.gunhaId;
      if (!gunhaId) {
        message.error("Gunha Id not found");
        return;
      }
      if (!record?.id) {
        message.error("Request Id not found");
        return;
      }
      gunhaIds.push(gunhaId);
      ids.push(record.id);
    }

    this.setState({ approveLoading: true });
    adminService
      .deleteGunaHideReuqest({ gunhaId: gunhaIds, id: ids })
      .then(() => {
        message.success(
          selectedRequests.length > 1
            ? `${selectedRequests.length} requests approved successfully`
            : "Approved successfully",
        );
        this.closeApproveConfirm();
        this.GunahaHideRequestList();
      })
      .catch(() => {
        message.error("Something went wrong");
        this.setState({ approveLoading: false });
      });
  };

  render() {
    console.log("props", this.props);
    // const { pc_cities } = this.props.professionals;
    const { t } = this.context;
    const {
      filteredData,
      pagination,
      loading,
      selectedCity,
      searchText,
      approveFilter,
      cities,
      selectedRowKeys,
      selectedRequests,
    } = this.state;
    const pendingRecords = this.getPendingRecords();
    const selectedPendingCount = this.getSelectedPendingRecords().length;
    const allPendingSelected =
      pendingRecords.length > 0 &&
      selectedPendingCount === pendingRecords.length;
    const somePendingSelected =
      selectedPendingCount > 0 && selectedPendingCount < pendingRecords.length;
    const showClearBtn =
      (this.state.appliedCity !== undefined &&
        this.state.appliedCity !== null &&
        this.state.appliedCity !== "") ||
      Boolean(String(this.state.appliedSearchText || "").trim());
    const columns = [
      {
        title: t("sr.no"),
        dataIndex: "srNo",
        key: "srNo",
        width: 70,
        render: (_, __, rowIndex) =>
          (pagination.current - 1) * pagination.pageSize + rowIndex + 1,
      },
      {
        title: t("user_id"),
        dataIndex: "userid",
        key: "userid",
        onHeaderCell: () => ({
          style: {
            backgroundColor: "#fff3e0",
            color: "#000",
            fontWeight: "bold",
          },
        }),
        onCell: () => ({
          style: {
            backgroundColor: "#fff3e0",
            color: "#000",
          },
        }),
        render: (text, record) => (
          <div style={{ whiteSpace: "pre-line" }}>
            {[record.userid, record.user_district_name]
              .filter(Boolean)
              .join("\n")}
          </div>
        ),
      },
      {
        title: t("accused_name"),
        dataIndex: "name",
        key: "name",
        render: (text, record) => (
          <div style={{ whiteSpace: "pre-line" }}>
            <Button
              type="link"
              style={{ padding: 0, height: "auto" }}
              onClick={() => this.onViewAccusedForm(record.masterId)}
            >
              {record.name}
            </Button>
          </div>
        ),
      },
      {
        title: t("law_and_section"),
        dataIndex: "lawSection",
        key: "lawSection",
        render: (text, record) => (
          <>
            {record?.registernumber && (
              <div>
                <strong>{t("crime_register_number")}:</strong>{" "}
                {record.registernumber}
              </div>
            )}

            <div style={{ whiteSpace: "pre-line" }}>
              {text?.replace(/,\s*/g, "\n")}
            </div>
          </>
        ),
      },
      {
        title: t("police_station"),
        dataIndex: "district_name",
        key: "district_name",
        render: (text, record) => (
          <div style={{ whiteSpace: "pre-line" }}>
            {[record.district_name, record.City].filter(Boolean).join("\n")}
          </div>
        ),
      },
      {
        title: t("reason"),
        dataIndex: "reason",
        key: "reason",
        render: (text, record) => (
          <div>
            {record.reason && (
              <div>
                <strong>{t("reason")}:</strong> {record.reason}
              </div>
            )}

            {record.ip_address && (
              <div>
                <strong>{t("ip_address")}:</strong> {record.ip_address}
              </div>
            )}

            {record.createdAt && (
              <div>
                <strong>{t("date")}:</strong>{" "}
                {moment(record.createdAt).format("DD-MM-YYYY")}
              </div>
            )}
          </div>
        ),
      },
      {
        title: t("action") || "Action",
        key: "action",
        fixed: "right",
        render: (_, record) => {
          const isApproved =
            record.is_approve === true || record.is_approve === 1;
          if (isApproved) {
            return <Tag color="green">Approved</Tag>;
          }
          return (
            <Button
              type="primary"
              onClick={() => this.openApproveConfirm(record)}
            >
              Approve
            </Button>
          );
        },
      },
    ];
    return (
      <>
        <div
          className="site-page-header-ghost-wrapper"
          style={{
            padding: "20px",
            background: "#fff",
            marginBottom: "20px",
          }}
        >
          <div
            style={{
              fontSize: 20,
              fontWeight: 600,
              lineHeight: "32px",
              marginBottom: 16,
              color: "rgba(0, 0, 0, 0.85)",
            }}
          >
            Crime Delete Request
          </div>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              alignItems: "center",
              gap: 12,
              width: "100%",
              marginBottom: 16,
            }}
          >
            <Select
              placeholder="Select State"
              value={this.state.selected_state}
              onChange={(value) => {
                this.setState(
                  {
                    selected_state: value,
                    selectedCity: undefined,
                    cities: [],
                  },
                  () => {
                    if (value) {
                      this.getStatesWiseCityData(value);
                    }
                  },
                );
              }}
              style={{ flex: "1 1 200px", minWidth: 180 }}
              showSearch
              allowClear
              optionFilterProp="children"
              filterOption={(input, option) =>
                option?.children?.toLowerCase().includes(input.toLowerCase())
              }
            >
              {this.state.states.map((item) => (
                <Option key={item.id} value={item.id}>
                  {item.state}
                </Option>
              ))}
            </Select>
            <Select
              allowClear
              showSearch
              placeholder="Please select a City"
              value={selectedCity}
              onChange={this.onCityChange}
              style={{ flex: "1 1 200px", minWidth: 180 }}
              optionFilterProp="children"
              filterOption={(input, option) =>
                String(option?.children || "")
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
            >
              {cities &&
                cities.length > 0 &&
                cities.map((res) => (
                  <Option key={res.id} value={res.id}>
                    {res.City}
                  </Option>
                ))}
            </Select>
            <Select
              value={approveFilter}
              onChange={this.onApproveFilterChange}
              style={{ flex: "0 1 180px", minWidth: 160 }}
            >
              <Option value="all">All</Option>
              <Option value="pending">Not Approved</Option>
              <Option value="approved">Approved</Option>
            </Select>
            <Input
              allowClear
              placeholder="Search..."
              value={searchText}
              onChange={this.onSearchTextChange}
              onPressEnter={this.onSearch}
              style={{ flex: "1 1 200px", minWidth: 180 }}
              prefix={<SearchOutlined />}
            />
            <Space style={{ flex: "0 0 auto" }}>
              <Button
                type="primary"
                icon={<SearchOutlined />}
                onClick={this.onSearch}
              >
                {t("find") || "Search"}
              </Button>
              {showClearBtn && (
                <Button icon={<ClearOutlined />} onClick={this.onClear}>
                  {t("clear") || "Clear"}
                </Button>
              )}
            </Space>
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginBottom: 12,
              flexWrap: "wrap",
              gap: 12,
            }}
          >
            <Checkbox
              checked={allPendingSelected}
              indeterminate={somePendingSelected}
              disabled={pendingRecords.length === 0}
              onChange={this.onSelectAllPending}
            >
              Select All ({pendingRecords.length})
            </Checkbox>
            <Button
              type="primary"
              disabled={selectedPendingCount === 0}
              onClick={this.openBulkApproveConfirm}
            >
              Approve Selected ({selectedPendingCount})
            </Button>
          </div>

          <Row justify="end" style={{ marginBottom: 12 }}>
            <Col>
              <div
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 8,
                  padding: "6px 14px",
                  background: "#6f42c1",
                  borderRadius: 6,
                  boxShadow: "0 2px 6px rgba(111, 66, 193, 0.25)",
                }}
              >
                <span style={{ fontSize: 13, color: "#fff" }}>
                  {t("total")}:
                </span>
                <strong style={{ fontSize: 16, color: "#fff" }}>
                  {filteredData.length}
                </strong>
              </div>
            </Col>
          </Row>

          <Table
            bordered
            loading={loading}
            scroll={{ x: "max-content" }}
            columns={columns}
            dataSource={filteredData}
            rowKey="id"
            rowClassName={() => "govt-table-row"}
            rowSelection={{
              selectedRowKeys,
              onChange: this.onSelectChange,
              getCheckboxProps: (record) => ({
                disabled: this.isApproved(record),
              }),
            }}
            pagination={{
              ...pagination,
              total: filteredData.length,
              showTotal: (total) => `Total ${total} records`,
            }}
            onChange={this.handleTableChange}
          />

          <Modal
            title="आरोपी प्रोफाइल"
            top
            visible={this.state.setCriminalViewModel}
            onOk={this.closeCriminalViewModel}
            onCancel={this.closeCriminalViewModel}
            width={95 + "%"}
          >
            <ViewFormModel
              key={this.props && this.props.user.id}
              dataStates={this.props.professionals}
              preventiveAction={this.state.preventiveAction}
            ></ViewFormModel>
          </Modal>

          <Modal
            title="Confirm Approve"
            visible={this.state.approveConfirmVisible}
            onOk={this.onApproveConfirm}
            onCancel={this.closeApproveConfirm}
            okText="Yes, Approve"
            cancelText="Cancel"
            confirmLoading={this.state.approveLoading}
            centered
          >
            <p>
              Are you sure you want to approve{" "}
              {selectedRequests.length > 1
                ? `${selectedRequests.length} selected requests`
                : "this request"}
              ? Related gunha and kalam records will be deleted.
            </p>
            {selectedRequests.length === 1 && (
              <p>
                <strong>Register No:</strong>{" "}
                {selectedRequests[0].registernumber}
                <br />
                <strong>Accused:</strong> {selectedRequests[0].name}
              </p>
            )}
            {selectedRequests.length > 1 && (
              <p>
                <strong>Selected:</strong> {selectedRequests.length} pending
                requests
              </p>
            )}
          </Modal>
        </div>
      </>
    );
  }
}

function mapStateToProps(state) {
  const { users, authentication, professionals } = state;
  const { user } = authentication;
  return {
    user,
    users,
    professionals,
  };
}
const connectGunhaHideRequest = connect(mapStateToProps)(GunhaHideRequest);
export { connectGunhaHideRequest as GunahaHideRequest };
